import {di} from "@dp-instant/core";
import {BurstWaveAction} from "@game/coregame/actions/BurstWaveAction";
import {Building} from "@game/coregame/ecs/entities/Building";
import {Fighter} from "@game/coregame/ecs/entities/Fighter";
import {Population} from "@game/coregame/view/Population";
import {TypesGame} from "@game/TypesGame";
import {injectable} from "inversify";
import {Entity} from "tick-knock";
import {CapitalView} from "./CapitalView";
import {getFightersSpeedPreset} from "../settings";

const fighterPreset = getFightersSpeedPreset();

@injectable()
export class Spawner extends Entity {
    public static UNITS_PER_WAVE = 5;
    public static BURST_WAVES_LEN = fighterPreset.BURST_WAVES_LEN;

    public selfBuilding?: Building;
    private _targetAmount: number;
    private _targetBuilding: Building;
    private _spawnRoutineTimeout: any;
    private _spawnRoutine = () => this.spawnRoutine();

    spawnAndSend(amount: number, target: Building) {
        this.stopRoutine();
        this._targetAmount = amount;
        this._targetBuilding = target;
        this.startRoutine();
    }
    private spawnRoutine() {
        const allocateAmount = Math.min(this._targetAmount, Spawner.UNITS_PER_WAVE);
        const population = this.selfBuilding?.get(Population);
        if (population) {
            const amount = population.allocate(allocateAmount);

            if (amount > 0 && this._targetAmount > 0) {
                this._targetAmount -= amount;

                di.get<BurstWaveAction>(TypesGame.actions.burst).run({
                    spawner: this,
                    amount,
                    target: this._targetBuilding
                });
                this._spawnRoutineTimeout = setTimeout(this._spawnRoutine, this.burstDelay * 1000);
            }
        }
    }
    public get burstDelay(): float {
        const scaleMult = 100; // this.selfBuilding?.get(CapitalView)?.scale.x || 1;
        const speed = Fighter.NORMAL_SPEED * scaleMult;
        return fighterPreset.BURST_DELAY;
        return 0.3; //(Spawner.BURST_WAVES_LEN * scaleMult) / speed;
    }
    private startRoutine() {
        this.spawnRoutine();
    }
    public stopRoutine() {
        clearTimeout(this._spawnRoutineTimeout);
    }
}
